export default function MarketingBlurb() {
  return (
    <div className="flex flex-col gap-6 md:gap-y-12 items-center">
      <h2 className="text-2xl md:text-3xl font-medium">
        Why Choose Transcript Genie?
      </h2>
      <div className="grid grid-cols-5 w-full mx-auto gap-6 md:gap-4">
        <div className="border-2 shadow-md col-span-5 md:col-span-3 flex flex-col lg:flex-row gap-6 md:gap-0 p-4 md:p-6 rounded-lg bg-white z-20">
          <div className="flex flex-col gap-y-2">
            <h4 className="text-2xl font-semibold text-primary">
              Global Transcript Compatibility
            </h4>
            <p className="md:w-11/12">
              {`Process transcripts from diverse educational systems worldwide. Streamline your international admissions with ease, whether handling documents from India, China, or any other country.`}
            </p>
          </div>
          <img
            src={"/blurb/globe.png"}
            className="object-cover w-11/12 md:w-fit md:object-contain max-w-md mx-auto"
            alt="Global compatibility"
            width={1000}
            height={1000}
          />
        </div>
        <div className="border-2 shadow-md col-span-5 md:col-span-2 flex flex-col gap-6 md:gap-0 p-4 md:p-6 rounded-lg bg-white z-20">
          <div className="flex flex-col gap-y-2">
            <h4 className="text-2xl font-semibold text-primary">
              AI-Powered Accuracy
            </h4>
            <p className="mw-11/12">
              {`Leverage advanced AI to ensure precise and consistent grade conversion and analysis. Minimize errors and standardize your admissions process across diverse grading systems.`}
            </p>
          </div>
          <img
            src={"/blurb/ai.png"}
            className="object-cover w-fit mx-auto max-w-52"
            alt="AI-powered accuracy"
            width={1000}
            height={1000}
          />
        </div>
        <div className="border-2 shadow-md col-span-5 md:col-span-2 flex flex-col px-4 pt-4 md:px-6 md:pt-6 gap-6 rounded-lg">
          <div className="flex flex-col gap-y-2">
            <h4 className="text-2xl font-semibold text-primary">
              Bulk Transcript Processing
            </h4>
            <p className="w-full">
              {`Effortlessly process transcripts in bulk processing. Handle large volumes of applications efficiently, saving your admissions team valuable time and resources.`}
            </p>
          </div>
          <img
            src={"/blurb/pdf.png"}
            className="w-full md:h-52 md:object-contain"
            alt="Multi-page PDF support"
            width={1000}
            height={1000}
          />
        </div>
        <div className="border-2 shadow-md col-span-5 md:col-span-3 flex flex-col gap-10 p-4 md:px-6 md:pt-6 rounded-lg">
          <div className="flex flex-col gap-y-2">
            <h4 className="text-2xl font-semibold text-primary">
              Streamlined Admissions Process
            </h4>
            <p className="mw-11/12">
              {`Reduce reliance on manual grade conversions and time-consuming transcript reviews. Accelerate your admissions cycle and cut operational costs with our AI-powered solution built for university admissions teams.`}
            </p>
          </div>
          <img
            src={"/blurb/time.png"}
            className="object-cover mx-auto w-full max-w-2xl"
            alt="Streamlined process"
            width={1000}
            height={1000}
          />
        </div>
      </div>
    </div>
  );
}
